import gql from 'graphql-tag';

export const CREATE_OVERALL_CONFIDENCE = gql`
  mutation createOverallConfidence($score: Int, $feedback: String) {
    createOverallConfidence(score: $score, feedback: $feedback)
  }
`;
